import React from 'react';
import Login from '../containers/Login';
import PublicLayout from '../layouts/public-layout/public-layout';

const LoginContainer = (props) => <PublicLayout title="Sign In" component={Login} props={props} />;
export default LoginContainer;
